module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-domain"
  }, [_c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "domain-header"
  }, [_c('div', {
    staticClass: "cl-container title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.sam_assignment')) + "\n      "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.catDomainGuide",
      modifiers: {
        "catDomainGuide": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('SubHeaderTab', {
    attrs: {
      "items": _vm.catSubjects,
      "selectedId": _vm.selectedSubject
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1), _vm._v(" "), (_vm.busy) ? _c('LoadingBounce') : [_c('div', {
    staticClass: "domain-cover"
  }, [_c('div', {
    staticClass: "cl-container cover-container"
  }, [_c('div', {
    staticClass: "cover-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img-main-sam.png",
      "alt": "sam"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-description"
  }, [(_vm.busy) ? _c('span', [_vm._v(_vm._s(_vm.$t('common.sam_loading')))]) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCatDescription)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "domain-container"
  }, [_c('div', {
    staticClass: "domain-title"
  }, [_vm._v(_vm._s(_vm.$t('common.domain')) + " " + _vm._s(_vm.catSubjectDomainsLength))]), _vm._v(" "), _c('div', {
    staticClass: "row px-14"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "col-lg-12 col-xs-12 col-md-12"
  }, [_c('LoadingBounce')], 1) : [(_vm.catSubjectDomainsLength === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('common.empty_domain_assignment')
    }
  }) : _vm._l((_vm.filterCatSubjectDomains), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-6 col-xs-12 col-md-12 domain"
    }, [(value.cat && (value.cat.is_first_cat || !value.cat.is_completed)) ? _c('div', {
      staticClass: "domain-state-icon",
      style: ({
        'border-bottom-color': _vm.selectedSubjectColor
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cl-card"
    }, [_c('div', {
      staticClass: "domain-name"
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" "), _c('div', {
      staticClass: "domain-state"
    }, [(!value.cat) ? [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-8 domain-progress"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('domain.need_first_problem_solve')) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.id, true)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.first_problem_solve')) + " >\n                      ")])])]), _vm._v(" "), _c('progress-bar', {
      staticClass: "domain-progress-bar",
      attrs: {
        "value": 0,
        "bgColor": _vm.selectedSubjectColor,
        "height": 6
      }
    })] : (value.cat && value.cat.is_completed) ? [_c('div', {
      staticClass: "row",
      style: ({
        'padding': '16px 0px 16px 0px'
      })
    }, [_c('div', {
      staticClass: "col-8 domain-score"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.recent_score')) + " \n                      "), _c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                        " + _vm._s(value.proficiency_score || '-') + _vm._s(_vm.$t('common.score_value')) + "\n                      ")]), _vm._v(" \n                      " + _vm._s(_vm.$t('common.rank')) + "\n                      "), (_vm.isGradeTotal(value.rank && value.rank.grade_total)) ? [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                          " + _vm._s(_vm.quizProgressValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-') + "%\n                        ")])] : [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("-%")]), _vm._v(" \n                        " + _vm._s(_vm.$t('common.standard_before_update')) + "\n                      ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': '#00C896'
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.id, false)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.problem_solve')) + " >\n                      ")])])])] : (value.cat && value.cat.is_first_cat) ? [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-8 domain-progress",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                      " + _vm._s(_vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count)) + "% \n                      " + _vm._s(_vm.$t('common.first_problem_prgress')) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url, true)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.continu_solve')) + " >\n                      ")])])]), _vm._v(" "), _c('progress-bar', {
      staticClass: "domain-progress-bar",
      attrs: {
        "value": _vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count),
        "bgColor": _vm.selectedSubjectColor,
        "height": 6
      }
    })] : (value.cat && !value.cat.is_completed) ? [_c('div', {
      staticClass: "row",
      style: ({
        'padding': '16px 0px 16px 0px'
      })
    }, [_c('div', {
      staticClass: "col-8 domain-score"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.recent_score')) + " \n                      "), _c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                        " + _vm._s(value.proficiency_score || '-') + _vm._s(_vm.$t('common.score_value')) + "\n                      ")]), _vm._v(" \n                      " + _vm._s(_vm.$t('common.rank')) + "\n                      "), (_vm.isGradeTotal(value.rank && value.rank.grade_total)) ? [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                          " + _vm._s(_vm.quizProgressValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-') + "%\n                        ")])] : [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("-%")]), _vm._v(" " + _vm._s(_vm.$t('common.standard_before_update')) + "\n                      ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.continu_solve')) + " >\n                      ")])])])] : _vm._e()], 2)])])
  })], _vm._v(" "), (_vm.filterCatSubjectDomains.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)])], _vm._v(" "), _c('CatDomainGuide', {
    attrs: {
      "id": "catDomainGuide"
    }
  }), _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.okSnackBar()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPrimeModal) ? _c('PrimeModal', {
    attrs: {
      "benefitTitle": _vm.$t('prime.first_solve_complete'),
      "isUnsupportText": true
    },
    on: {
      "closeModal": function($event) {
        return _vm.closePrimeModal()
      },
      "okModal": function($event) {
        return _vm.okPrimeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c13aa242","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-domain/views/CatDomainView.vue
// module id = 1608
// module chunks = 1